<template>
  <v-container fluid tag="section">
     <base-material-table
      outlined
      :item="item"
      ref="table"
      single-expand
      >
      <template v-slot:condition>
        <v-col cols="12" md="2">
          <v-select
            hide-details
            outlined dense
            label="年份选择"
            :items='yearItems'
            @change="loadData"
            item-text="label"
            item-value="value"
            v-model='item.params.year'>
          </v-select>
        </v-col>
        <v-col cols="12" md="2">
          <v-select
            hide-details
            outlined dense
            label="月份选择"
            :items="monthItems"
            @change="loadData"
            item-text="label"
            item-value="value"
            v-model='item.params.month'>
          </v-select>
        </v-col>
      </template>
    </base-material-table>
    <add-view :item='addModal' @on-load-data='loadData'></add-view>
  </v-container>
</template>

<script>
  import { selectData, selectMonthData } from '@/utils/tool.js'
  import AddView from './components/Add'

  export default {
    name: 'OfficeScore',
    components: {
      AddView
    },
    data() {
      return {
        tab: 0,
        addModal: { show: false },
        monthItems: selectMonthData(),
        yearItems: selectData(3),
        item: {
          mobile: true,
          path: 'office/score/list',
          topButtons: [
            { event: 'search', show: true }
          ],
          params: {
            month: Number(this.$moment().format('MM')),
            year: Number(this.$moment().format('YYYY'))
          },
          headers: [
            {
              text: '头像',
              align: 'center',
              divider: true,
              sortable: false,
              value: 'userInfo.avatar',
              mobile: true,
              width: 100,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              avatar: (val) => val
            },
            {
              text: '总分',
              align: 'center',
              divider: true,
              sortable: false,
              value: 'allScore',
              mobile: true,
              width: 100,
              class: 'fixed-left',
              cellClass: 'fixed-left',
              formatter: (val) => val.toFixed(2)
            },
            {
              text: '姓名',
              align: 'center',
              divider: true,
              value: 'userInfo.name',
              mobile: true,
              sortable: false,
              copy: true,
              width: 120,
              search: { type: 'input', mobile: true, secKey: 'name' }
            },
            {
              text: '业绩(15分)',
              align: 'center',
              divider: true,
              value: 'achievementScore',
              mobile: true,
              sortable: true,
              width: 120
            },
            {
              text: '回款(20分)',
              align: 'center',
              divider: true,
              value: 'returnedScore',
              mobile: true,
              sortable: true,
              width: 120
            },
            {
              text: '首付款(10分)',
              align: 'center',
              divider: true,
              value: 'firstReturnedScore',
              mobile: true,
              sortable: true,
              width: 140
            },
            {
              text: '客户跟进(15分)',
              align: 'center',
              divider: true,
              value: 'customerScore',
              mobile: true,
              sortable: true,
              width: 150
            },
            {
              text: '客户服务(10分)',
              align: 'center',
              divider: true,
              value: 'serviceScore',
              mobile: true,
              sortable: true,
              width: 150
            },
            {
              text: '专业度(5分)',
              align: 'center',
              divider: true,
              value: 'professionScore',
              mobile: true,
              sortable: true,
              width: 140
            },
            {
              text: '团队协作(5分)',
              align: 'center',
              divider: true,
              value: 'teamScore',
              mobile: true,
              sortable: true,
              width: 150
            },
            {
              text: '创新能力(5分)',
              align: 'center',
              divider: true,
              value: 'innovateScore',
              mobile: true,
              sortable: true,
              width: 150
            },
            {
              text: '考勤(10分)',
              align: 'center',
              divider: true,
              value: 'checkWorkScore',
              mobile: true,
              sortable: true,
              width: 120
            },
            {
              text: '汇报(6分)',
              align: 'center',
              divider: true,
              value: 'reportScore',
              mobile: true,
              sortable: true,
              width: 120
            },
            {
              text: '乐捐(4分)',
              align: 'center',
              value: 'penaltyScore',
              mobile: true,
              divider: true,
              sortable: true,
              width: 120
            },
            {
              text: '评分月度',
              align: 'center',
              value: 'year',
              mobile: true,
              sortable: false,
              width: 120,
              formatter: (val, row) => `${val}年${row.month}月`
            },
            {
              text: '操作',
              align: 'center',
              mobile: true,
              sortable: false,
              width: 100,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              actions: [
                {
                  text: '评分',
                  color: 'primary',
                  icon: 'mdi-pencil',
                  onClick: (row) => this.addModal = { show: true, data: row },
                  disable: () => !this.$_has('office-score-edit')
                }
              ]
            }
          ]
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>

<style>
</style>
